/**
 * Router para Residentes.
 *
 * Maneja las rutas y el layout para usuarios con perfil de residente.
 */

import React, { useContext } from "react";
import { Routes, Route, Outlet } from "react-router-dom";

// Css
import "./index.css";
import "./chart.css";
import "./step.css";
import "../css/style_citoplus.css";

// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./pages/ScrollToTop";

// Dashboard
import ResidenteDashboardHome from "./components/CitoPlus/residentes/Dashboard/Home";

// Visitantes
import VisitantesList from "./components/CitoPlus/residentes/Visitantes/VisitantesList";

// Pre-registros
import PreRegistrosList from "./components/CitoPlus/residentes/PreRegistros/PreRegistrosList";
import PreRegistroForm from "./components/CitoPlus/residentes/PreRegistros/PreRegistroForm";
import Proximamente from "./components/CitoPlus/residentes/Proximamente";

// Zonas Sociales
import MisReservas from "./components/CitoPlus/residentes/ZonasSociales/MisReservas";
import ZonasDisponibles from "./components/CitoPlus/residentes/ZonasSociales/ZonasDisponibles";

// Correspondencia
import CorrespondenciaList from "./components/CitoPlus/residentes/Correspondencia/CorrespondenciaList";

// Autorizaciones
import AutorizacionesList from "./components/CitoPlus/residentes/Autorizaciones/AutorizacionesList";
import AutorizacionForm from "./components/CitoPlus/residentes/Autorizaciones/AutorizacionForm";
import AutorizacionDetail from "./components/CitoPlus/residentes/Autorizaciones/AutorizacionDetail";

// Páginas de error
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";

import { ThemeContext } from "../context/ThemeContext";
import { useResidenteDataInit } from "../hooks/useResidenteDataInit";

const RouterResidentes = () => {
  // Garantiza que los datos del residente estén en el store antes de renderizar.
  // Cubre el caso de F5 / reload donde el store de Redux se vacía.
  const { isLoading } = useResidenteDataInit();

  const allroutes = [
    // Dashboard
    { url: "", component: <ResidenteDashboardHome /> },
    { url: "dashboard-residente", component: <ResidenteDashboardHome /> },

    // Visitantes
    { url: "visitantes", component: <VisitantesList /> },

    // Pre-registros
    { url: "pre-registros", component: <PreRegistrosList /> },
    { url: "pre-registro-crear", component: <PreRegistroForm /> },

    // Zonas Sociales
    { url: "zonas-sociales", component: <ZonasDisponibles /> },
    { url: "mis-reservas", component: <MisReservas /> },

    // Correspondencia
    { url: "correspondencia", component: <CorrespondenciaList /> },

    // Autorizaciones
    { url: "autorizaciones", component: <AutorizacionesList /> },
    { url: "autorizacion-crear", component: <AutorizacionForm /> },
    { url: "autorizacion/:slug", component: <AutorizacionDetail /> },
  ];

  if (isLoading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
          <Route path="*" element={<Error404 />} />
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);

  return (
    <>
      <div
        id="main-wrapper"
        className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${menuToggle ? "menu-toggle" : ""}`}
      >
        <Nav />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 45 }}
        >
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default RouterResidentes;
